import CasinoImageBox from "components/casinoImageBox"

const CasinoLayout = ({ casinoImages, CreateAndLaunchWCOCasino, iframeUrl, setIframeUrl }) => {
    return (
        <div className='relative w-full'>
            <div className="grid grid-cols-12 lg:px-[6px]">
                <div className="col-span-12">
                    <div className="bg-[#fff] h-auto relative">
                        <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>
                            <span className="max-w-[220px] lg:max-w-[465px] float-left m-0 overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap">Casino</span>
                        </p>
                    </div>
                </div>
                <div className="col-span-12">
                    {
                        !iframeUrl ?
                            <>
                                <section className="block">
                                    <div className="ml-auto mr-auto  w-full">
                                        <div className="grid grid-cols-12 gap-y-[10px] !mt-[20px] !mb-[.5rem] ">
                                            {
                                                casinoImages.map((image, index) => (
                                                    <CasinoImageBox key={index} src={image.src} title={image.title} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} provider_code={image.provider_code} game_code={image.game_code} type={image.type} />
                                                ))
                                            }
                                        </div>
                                    </div>
                                </section>
                            </>
                            :
                            <>
                                <div className="absolute  w-[30px] text-center">
                                    <i className="fa fa-times popup-cross font-bold text-[#fff] cursor-pointer" onClick={() => setIframeUrl('')}></i>
                                </div>
                                <iframe className="w-full h-[73vh] border-[0px]" title="iframe" src={iframeUrl}></iframe>
                            </>
                    }

                </div>
            </div>

        </div>
    )
}

export default CasinoLayout